import React from 'react';
import { BaseComponent } from 'kryfe-lib';
import { connect } from 'react-redux';

import ApplyFormComp from './ApplyFormComp';
import './index.less';

import { getCity, commitInfo } from 'pages/newHome/actions';

class ApplyFormCompIndex extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <ApplyFormComp
          ApplyFormComp={this.props.ApplyFormComp}
          getCity={this.props.getCity}
          commitInfo={this.props.commitInfo}
        />
      </React.Fragment>
    );
  }
}

let mapStateToProps = state => ({
  system: state.__system__,
  ApplyFormComp: state.home.banner.ApplyFormComp,
});

let mapDispatchToProps = {
  getCity,
  commitInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplyFormCompIndex);



// WEBPACK FOOTER //
// ./src/pages/newHome/components/ApplyForm/index.jsx